/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GraduatoriaComunicazioneSummaryDTO { 
    /**
     * Righe candidate al dispatch (esito non null, non già comunicate)
     */
    inviate?: number;
    /**
     * Righe saltate: esito null (A-imp non allocato) oppure già comunicate (anti-spam)
     */
    saltate?: number;
    /**
     * Numero totale di righe della graduatoria confermata
     */
    righe_totali?: number;
}

